import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToggleInputUIComponent } from "./toggle-input.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
	declarations: [ToggleInputUIComponent],
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	exports: [ToggleInputUIComponent]
})
export class ToggleInputModule {}
